import script from "./CompetitorsTargetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitorsTargetsView.vue?vue&type=script&setup=true&lang=js"

import "./CompetitorsTargetsView.vue?vue&type=style&index=0&id=7923ac80&lang=scss"

const __exports__ = script;

export default __exports__